export const rapportStatusMap: Record<number, string> = {
  0: "Créé",
  1: "Validé",
  2: "Publié (Interne)",
  3: "Publié (Public)",
};

export function codeToRapportStatus(code: number): string {
  return rapportStatusMap[code] ?? rapportStatusMap[0];
}

export default {
  rapportStatusMap,
  codeToRapportStatus,
};
